import { useFilterStore, useTVStore } from '@/shared/store'
import { sortObjectsByName } from '@/shared/lib'
import { FilterCategory } from '@/shared/store/types'
import { useTranslation } from 'react-i18next'

const useCategoriesForFilteringStreamIQ = () => {
    const { setFilterCategories } = useFilterStore()
    const { channelsData } = useTVStore()
    const { t: translate } = useTranslation()

    const getCategoriesForFiltering = () => {
        const genres = channelsData.map((channel) => channel.list).flat()
        const uniqueGenres = [...new Set(genres)].map((item) => translate(item))
        const categories: FilterCategory[] = []

        uniqueGenres.forEach((allCategoriesList) => {
            const existingObject = categories.find(
                (obj) => obj.name === allCategoriesList
            )

            if (existingObject) {
                existingObject.itemsAmount += 1
            } else {
                categories.push({
                    name: translate(allCategoriesList),
                    itemsAmount: 1,
                })
            }
        })

        const sortedArray = sortObjectsByName(categories, (obj) => obj.name)

        sortedArray.unshift({
            name: translate('genreFavorites'),
            itemsAmount: 0,
        })

        const filters = sortedArray
            .filter((item) => item.name !== 'kids')
            .filter(Boolean)

        setFilterCategories(filters)
    }

    return { getCategoriesForFiltering }
}

export { useCategoriesForFilteringStreamIQ }
